import { useQuery } from '@tanstack/react-query';
import { requestUpcomingPayments } from './upcomingPaymentsApi';

/** Exported so a future Cancel mutation can invalidate this query after a successful cancel. */
export const upcomingPaymentsKey = ['payments', 'upcomingPayments'] as const;

/** The member's scheduled future one-time payments for the Payment Center's Upcoming Payments table. */
export function useUpcomingPayments() {
  return useQuery({
    queryKey: upcomingPaymentsKey,
    queryFn: requestUpcomingPayments,
  });
}
